import { formatRelative, parseISO } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';

const displayMessageTime = (isoTimestamp, locale) =>
  formatRelative(parseISO(isoTimestamp), new Date(), {
    locale: locale === 'fr' ? fr : enUS,
  });

export { displayMessageTime };
